<template>
  <button v-on:click="go($event)">
    <p>
      <img :class="color" v-if="image" :src="imagePath" width="20" height="20" />
      {{ text.toUpperCase() }}
      <span class="bold">{{ bold.toUpperCase() }}</span>
    </p>
  </button>
</template>

<script>
export default {
  props: ['text', 'href', 'image', 'bold', 'color'],
  computed: {
    imagePath() {
      return require(`../../assets/${this.image}`);
    },
  },
  methods: {
    go() {
      if (!this.href) {
        this.$emit('go');
        return;
      }

      this.$router.push(this.href).catch(err => {
        this.$log.error(err);
      });
    },
  },
};
</script>

<style scoped>
button {
  color: white;
  line-height: 22px;
  letter-spacing: 0.46px;
  font-weight: 300;
  width: 230px;
  padding-left: 20px;
  font-size: 16px;
  background-color: #0d52a0;
  border: none;
  margin: auto;
  cursor: pointer;
  border: none;
}

.bold {
  font-weight: 600;
}
@supports (-moz-appearance: none) {
  .bold {
    font-weight: 500;
  }
}
img {
  float: left;
}

.white {
  filter: brightness(0) invert(1);
}
</style>
